import React, { ComponentType } from 'react';
import { styled } from 'linaria/react';
import urlLanguageParse from 'presentation/utils/urlLanguageParse';
import withLanguage from 'presentation/hocs/withLanguage';

import { Layer } from './Layer';

interface OuterProps {
  layer: Layer;
}
interface InnerProps extends OuterProps {
  currentLanguage: string;
}

const StaticBackground = styled.div<{ layer: Layer; imageUrl: string }>`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: ${({ layer }) => layer.focus ?? 'center center'};
  background-repeat: no-repeat;
  background-image: ${({ imageUrl }) => `url(${imageUrl})`};
`;

export const Static = ({ layer, currentLanguage }: InnerProps) => {
  const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  const image = isChrome === true && layer.webpUrl != null ? layer.webpUrl : layer.imageUrl;
  const imageUrl = urlLanguageParse(image ?? '', currentLanguage);

  return <StaticBackground role="presentation" layer={layer} imageUrl={imageUrl} />;
};

Static.displayName = 'Static';

export default withLanguage(Static) as ComponentType<OuterProps>;
